import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Paper, Typography, Alert, Box, Divider, CircularProgress } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import api from '../api';

export default function Register() {
  const [form, setForm] = useState({
    nom: '',
    prenom: '',
    email: '',
    password: '',
    etablissement: '',
    role: 'prof'
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [googleLoading, setGoogleLoading] = useState(false);
  const navigate = useNavigate();
  const googleEnabled = Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const normalizeError = (err) => {
    return err.response?.data?.error || 'Erreur lors de la création du compte';
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await api.post('/users/register', form);
      setSuccess('Compte créé avec succès ! Vous pouvez vous connecter.');
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      setError(normalizeError(err));
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    if (!credentialResponse?.credential || googleLoading) return;

    setError('');
    setSuccess('');
    setGoogleLoading(true);

    try {
      const res = await api.post('/users/google', {
        credential: credentialResponse.credential
      });

      if (res.data?.token) {
        localStorage.setItem('token', res.data.token);
        window.location.href = '/';
      } else {
        setError('Aucun token reçu depuis Google');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la connexion Google');
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Paper elevation={3} sx={{ p: 4, minWidth: 350 }}>
        <Typography variant="h6" gutterBottom>
          Créer un compte Prof
        </Typography>

        {googleEnabled && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Créer ou retrouver un compte avec Gmail ou compte Google académique
            </Typography>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => setError('Inscription Google impossible.')}
              useOneTap={false}
              text="signup_with"
              shape="pill"
              width="100%"
            />
            {googleLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5 }}>
                <CircularProgress size={20} />
              </Box>
            )}
            <Divider sx={{ my: 2 }}>ou</Divider>
          </Box>
        )}

        {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ my: 2 }}>{success}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Nom"
            name="nom"
            value={form.nom}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Prénom"
            name="prenom"
            value={form.prenom}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Établissement"
            name="etablissement"
            value={form.etablissement}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Email académique ou personnel"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Mot de passe"
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Créer le compte
          </Button>
          <Button
            onClick={() => navigate('/login')}
            fullWidth
            sx={{ mt: 1 }}
            variant="outlined"
          >
            Retour à la connexion
          </Button>
        </form>
      </Paper>
    </Box>
  );
}